import React, { useState } from 'react';
import { Button, Dropdown, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined, CloudOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme, type RootState, type ThemeMode } from 'sama-shared';

/*
 * Selector de tema Claro / Oscuro / Océano (firma Brasa).
 * Dropdown compacto: en desktop muestra icono + etiqueta, en móvil solo icono.
 * Despacha setTheme (el toggle binario clásico se conserva para otros paquetes).
 */

const OPTIONS: { key: ThemeMode; label: string; icon: React.ReactNode }[] = [
  { key: 'light', label: 'Claro', icon: <SunOutlined style={{ color: '#ffb020' }} /> },
  { key: 'dark', label: 'Oscuro', icon: <MoonOutlined /> },
  { key: 'ocean', label: 'Océano', icon: <CloudOutlined style={{ color: '#38bdf8' }} /> },
];

export const ThemeSwitcher: React.FC<{ isMobile?: boolean }> = ({ isMobile = false }) => {
  const dispatch = useDispatch();
  const mode = (useSelector((state: RootState) => state.auth.theme) ?? 'dark') as ThemeMode;
  const current = OPTIONS.find((o) => o.key === mode) ?? OPTIONS[1];
  // El Tooltip ("información desplegable") y el menú del Dropdown compiten por el
  // mismo trigger: sin control, al hacer click ambos overlays quedan visibles y
  // se solapan. Se controla `open` para ocultar el Tooltip mientras el menú está abierto.
  const [open, setOpen] = useState(false);

  return (
    <Dropdown
      menu={{
        selectedKeys: [mode],
        onClick: ({ key }) => {
          dispatch(setTheme(key as ThemeMode));
          setOpen(false);
        },
        items: OPTIONS.map((o) => ({ key: o.key, label: o.label, icon: o.icon })),
      }}
      trigger={['click']}
      placement="bottomRight"
      open={open}
      onOpenChange={setOpen}
    >
      <Tooltip title="Cambiar tema" open={open ? false : undefined} mouseEnterDelay={0.4}>
        <Button
          type="text"
          aria-label={`Tema actual: ${current.label}. Cambiar tema`}
          aria-haspopup="menu"
          aria-expanded={open}
          icon={current.icon}
          style={{ borderRadius: 10, height: 40, fontWeight: 600 }}
        >
          {!isMobile && current.label}
        </Button>
      </Tooltip>
    </Dropdown>
  );
};

export default ThemeSwitcher;
